export const isFunction = functionToCheck => functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';

export const findAndReplace = (array = [], element, key) => {
    if (!isFunction(key)) {
        throw new Error('Key argument must be a function');
    }

    const newArray = [...array];
    let found = false;

    for (let i = 0; i < newArray.length; i += 1) {
        if (key(element) === key(newArray[i])) {
            found = true;
            newArray[i] = element;
        }
    }

    if (!found) {
        throw new Error('Element not found in array');
    }

    return newArray;
};

export const hasMember = (array, member) => array.indexOf(member) !== -1;

export function convertArrayToHash(array, key = x => x.id) {
    if (!isFunction(key)) {
        throw new Error('Key argument must be a function');
    }

    const hash = {};

    for (let i = 0; i < array.length; i += 1) {
        const elementKey = key(array[i]);
        hash[elementKey] = array[i];
    }

    return hash;
}

export function removeDuplicates(arrArg) {
    return arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
}

export const flatten = arr => arr.reduce((flat, next) => flat.concat(next), []);

const createHashWithField = (array, field) => {
    const hash = {};
    array.forEach((elem) => {
        const key = elem[field];
        hash[key] = elem;
    });
    return hash;
};

const createHashWithoutField = (array) => {
    const hash = {};
    array.forEach((elem) => {
        hash[elem] = elem;
    });
    return hash;
};

export const createHashOfArray = (array, field = null) => {
    if (field) return createHashWithField(array, field);

    return createHashWithoutField(array);
};
